import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20elegant%20abstract%20background%20with%20gradient%20golden%20and%20cream%20tones%2C%20soft%20geometric%20patterns%2C%20luxurious%20minimalist%20composition%2C%20smooth%20texture%2C%20high-end%20aesthetic%2C%20warm%20ambient%20glow%2C%20professional%20and%20trustworthy%20atmosphere&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="hth官方平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
            hth官方平台
          </h1>
          <p className="mt-4 md:mt-6 text-lg md:text-2xl text-background-200 font-light max-w-2xl mx-auto leading-relaxed">
            正品保障 · 极速响应 · 全方位服务支持
          </p>
          <p className="mt-3 md:mt-4 text-sm md:text-base text-background-300/80 max-w-xl mx-auto">
            无论您是新用户还是老会员，hth都能为您带来卓越体验
          </p>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/membership"
              className="whitespace-nowrap inline-flex items-center px-8 py-3 text-sm md:text-base font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer"
            >
              探索会员权益
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center px-8 py-3 text-sm md:text-base font-medium rounded-md border border-background-300/60 text-background-50 hover:bg-background-50/10 transition-all cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}